export default "__VITE_ASSET__Ba$OsynC__"